import type { ImageCrop, SiteContent } from '../content/types';

export type Litter = {
  id: string;
  title: string;
  description: string;
  expectedDate: string;
  spotsLeft: number;
  status: string;
  imageUrl: string | null;
  imageCrop?: ImageCrop | null;
};

export async function getContent(signal?: AbortSignal): Promise<{ content: SiteContent; litters: Litter[] }> {
  const response = await fetch('/api/content', { signal });
  if (!response.ok) throw new Error('Unable to load site content');
  return response.json() as Promise<{ content: SiteContent; litters: Litter[] }>;
}

export async function postJson(path: string, body: unknown) {
  const response = await fetch(path, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error('Unable to submit. Please try again.');
  return response.json();
}
